import { render, staticRenderFns } from "./PhoneDebugPage.vue?vue&type=template&id=242cf076&scoped=true&"
import script from "./PhoneDebugPage.vue?vue&type=script&lang=js&"
export * from "./PhoneDebugPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242cf076",
  null
  
)

export default component.exports